import React from 'react'
import { Filter } from 'components/Filter'
import { useHomeStore } from 'context/HomeStore'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { Box, Checkbox, FormControl, Grid, InputLabel } from '@material-ui/core'
import { Pagination } from 'asterX-UI/Pagination'
import { UpdateList } from 'components/UpdateList'
import { ChevronRight } from '@material-ui/icons'
import { useRoutes } from 'lib/hooks'
import { CONTRACT_PATH } from 'routes/constants.routes'
import { InfoCard } from 'components/InfoCard/InfoCard'
import { SUCCESS_COLORS } from 'asterX-UI'
import { getDaysLabel } from 'lib/utils'
import { useAuthStore } from 'context/AuthStore'
import ContractCard from 'components/ContractCard/ContractCard'
import { MainTabs } from '../../MainTabs'
import { useStyles } from './home-admin.styles'

const HomeAdmin = () => {
  const classes = useStyles()
  const { authStore } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const routes = useRoutes()

  const adminColumns = () => {
    return [
      <Grid item key="select-all">
        <FormControl className={classes.checkbox}>
          <Checkbox
            name={'selectAll'}
            onChange={homeStoreFunc?.handleSelectAllChange}
            checked={homeStore?.selectAll}
            id={'selectAll'}
            color={'primary'}
          />
          <InputLabel shrink htmlFor={'selectAll'} className={classes.checkboxLabel}>
            №
          </InputLabel>
        </FormControl>
      </Grid>,
      'Клиент',
      'LEVEL',
      'Филиал shinhan',
      'Продукт',
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('overdueDays')}>
        Дни просрочки {homeStoreFunc.getArrow('overdueDays')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('loanAmount')}>
        Сумма займа {homeStoreFunc.getArrow('loanAmount')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueTranchesSum')}>
        Сумма просрочки {homeStoreFunc?.getArrow('overdueTranchesSum')}
      </Box>,
      ''
    ]
  }

  const adminRows = () => {
    if (!homeStore?.contractList) return []

    return homeStore?.contractList.map(item => {
      const isSelected = homeStore.selectedRows.includes(item?.id)

      return [
        <Grid item key={item?.id}>
          <FormControl className={classes.checkbox}>
            <Checkbox
              name={`contractNumber-${item?.id}`}
              onChange={() => homeStoreFunc?.handleRowCheckboxChange(item?.id)}
              checked={isSelected}
              id={`contractNumber-${item?.id}`}
              color={'primary'}
            />
            <InputLabel shrink htmlFor={`contractNumber-${item?.id}`} className={classes.checkboxLabel}>
              {item?.contractNumber}
            </InputLabel>
          </FormControl>
        </Grid>,
        item?.clientFullName?.replace('null', '').trim() || '-',
        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{item?.level || '-'}</Grid>,
        item?.subdivisionName,
        item?.creditProductName,
        <Grid item>{`${item?.overdueDays || 0} ${getDaysLabel(item?.overdueDays)}`}</Grid>,
        item?.loanAmount?.toString()?.thousandSeparator(),
        item?.overdueTranchesSum?.toString()?.thousandSeparator(),
        {
          isButton: true,
          label: <ChevronRight />,
          data: { id: item?.id }
        }
      ]
    })
  }

  const handleOpenContract = row => {
    const { id } = row
    const current = homeStore.contractList.find(e => e?.id === id)
    if (current) {
      routes.goTo(`${CONTRACT_PATH}/${current.id}`)
    }
  }

  const tableData = {
    columns: adminColumns(),
    rows: adminRows()
  }

  const renderCardView = () => {
    return (
      <Box display="flex" flexDirection="column" style={{ gap: 16, marginBottom: 10 }}>
        {homeStore?.contractList?.length > 0 && (
          <Box className={classes.selectAll} onClick={homeStoreFunc?.handleSelectAllChange}>
            Выбрать все
          </Box>
        )}
        {homeStore?.contractList?.map(item => (
          <ContractCard key={item?.id} item={item} />
        ))}
      </Box>
    )
  }

  return (
    <>
      <MainTabs>
        <Grid container spacing={2} style={{ marginBottom: 16 }}>
          <Grid xs={12} lg={4} xl={3} item>
            <InfoCard label="Новые контракты" value={homeStore?.infoCard?.countFiltered} color={SUCCESS_COLORS[600]} />
          </Grid>
        </Grid>
        <Filter />
        {authStore.isMobile ? (
          renderCardView()
        ) : (
          <StandardTable
            tableData={tableData}
            onButtonClick={handleOpenContract}
            btnStyle={{
              backgroundColor: 'transparent',
              border: 'none',
              padding: 8,
              minWidth: 'auto',
              cursor: 'pointer'
            }}
          />
        )}

        <Grid item xs={12}>
          <Pagination
            count={Math.ceil(homeStore?.pagination?.count / 30)}
            page={homeStore?.pagination?.offset + 1}
            onChange={homeStoreFunc.handlePaginationChange}
            isMobile={authStore.isMobile}
          />
        </Grid>
      </MainTabs>
      <UpdateList />
    </>
  )
}

export default HomeAdmin
